
const state = {
	pageYOffset : 0,
}

const mutations = {
	setPageYOffset(state, payload){
		state.pageYOffset = payload;
	}
}

const actions = {
	setPageYOffset(context, payload){
		context.commit('setPageYOffset',payload);
	},
}

const getters = {
	getPageYOffset(state){
		return state.pageYOffset;
	}
}

export default {
	state,
	mutations,
	actions,
	getters
}



// WEBPACK FOOTER //
// ./src/store/modules/pageOffset.js